import * as yup from 'yup';

import { getFormatMessage, getDateMessage } from 'utils/schema';

const defaultShape = {
  name: yup.string(),
  description: yup.string(),
  status: yup.string(),
  createdAt: yup.string(),
  updatedAt: yup.string(),
  archivedAt: yup.string(),
};
const yupSchema = yup.object().shape(defaultShape);

export const infosSchemaBlock = [
  {
    key: 'name',
    label: getFormatMessage,

    _form: {
      label: getFormatMessage,

      id: 'name',
      name: 'name',
      type: 'text',
    },
  },
  {
    key: 'description',
    label: getFormatMessage,

    _form: {
      label: getFormatMessage,

      id: 'description',
      name: 'description',
      type: 'text',
    },
  },
  {
    key: 'usersIds',
    _form: {
      label: getFormatMessage,

      id: 'usersIds',
      name: 'usersIds',
      type: 'fieldset',
      /**
       *
       * @param {*} _entity
       * @param {*} key
       * @param {} options
       * [{ value: 'qO7TLflbsNRmqtPNmcO7tRZ16lp1', label: 'M' }]
       * @returns
       */
      inputs: (_entity, key, options) => {
        if (key && options) {
          const valuesOptions = options[key];
          if (valuesOptions) {
            return valuesOptions;
          }
        }
        return [];
      },
    },
  },
  {
    key: 'stationsIds',
    _form: {
      label: getFormatMessage,

      id: 'stationsIds',
      name: 'stationsIds',
      type: 'fieldset',
      /**
       *
       * @param {*} _entity
       * @param {*} key
       * @param {} options
       * [{ value: 'qO7TLflbsNRmqtPNmcO7tRZ16lp1', label: 'M' }]
       * @returns
       */
      inputs: (_entity, key, options) => {
        if (key && options) {
          const valuesOptions = options[key];
          if (valuesOptions) {
            return valuesOptions;
          }
        }
        return [];
      },
    },
  },
  {
    key: 'createdAt',
    label: getFormatMessage,
    content: getDateMessage,
  },
  {
    key: 'status',
    // label: getFormatMessage,
  },
];

export default {
  yupSchema,
  blocks: [infosSchemaBlock],
};
